import { Component, OnInit, Input } from '@angular/core';
import { GameLineUp, SCGameLineUpPlayer } from '../../../shared/models/GameModels';
import { TextDividerComponent } from '../text-divider/text-divider.component';
import { LineupPlayerCardComponent } from '../lineup-player-card/lineup-player-card.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-game-lineup',
    imports: [CommonModule, TextDividerComponent, LineupPlayerCardComponent, TranslateModule],
    templateUrl: './game-lineup.component.html',
    styleUrls: ['./game-lineup.component.css']
})
export class GameLineupComponent implements OnInit {
  @Input() LineUpInfo: SCGameLineUpPlayer[];
  @Input() TeamIcon: string;
  displayLineUp: GameLineUp;
  lineupMap = new Map<string, SCGameLineUpPlayer>();

  constructor() { }

  ngOnInit() {
    this.displayLineUp = new GameLineUp(this.LineUpInfo);
    for (const player of this.LineUpInfo) {
      this.lineupMap.set(`${player.LineCode}_${player.PositionCode}`, player);
    }
  }

}
